import React, { FC } from 'react';
import { MainComponent } from 'src/components/Main';

interface Props {}

export const MainPage: FC<Props> = () => {
  return <MainComponent />;
};
